import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ElementRef, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { ProspectModel } from '../../../shared/models/ProspectModel';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { spaceOnlyValidator } from '../../../shared/models/SavePropertyInputModel';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { CommonService } from '../../../shared/providers/common.service';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../../shared/providers/loader.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { ToastService } from '../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestService } from '../../../shared/providers/rest.service'
import { catchError, distinctUntilChanged, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { MatSelect } from '@angular/material/select';
/*import { CompleterData, CompleterService } from 'ng2-completer';*/

@Component({
  selector: 'app-prospects-add',
  templateUrl: './prospects-add.component.html',
  styleUrls: ['./prospects-add.component.css']
})
export class ProspectsAddComponent implements OnInit {

  @Input() propertyId: number;
  @Input() prospectId: number;
  @Input() IsPortfolio: boolean;
  @Input() prospect: any;
  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  IsEditMode = false as boolean;
  prospectModel = {} as ProspectModel;
  isSubmitted = false as boolean;
  prospectForm: FormGroup;
  fileTypes = '.PDF, .JPEG, .JPG';
  statusList: ILookUp[];
  editStatusList: ILookUp[];
  feedackList: any[];
  showFeedback = false as boolean;
  initialLoad = false;
  fileExtensionType = 'document'
  fileUploadType = 'multiple';
  clearFiles: number = 0;
  filesCollection = [];
  errorMessage: string;
  selectedFiles: string[] = [];
  removeModalRef: BsModalRef;
  @ViewChild('template') template: TemplateRef<any>;
  accounts: ILookUp[];
  inputFileUpload = {} as IFileUpload;
  documents: any[] = [];
  removeDocId: number[] = [];
  user: any;
  dataService: [];/*CompleterData;*/
  modalRef: BsModalRef;
  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  loading = false;
  //defaultText: IMultiSelectTexts = {
  //  defaultTitle: 'Select',
  //};
  defaultSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  isEditable = false;
  emailValid: boolean = true;
  emailvalidation: string = "";
  disableProspectDetails: boolean = false;
  allowEmailEdit: boolean = true;
  constructor(private _commonService: CommonService,
    private _dashboardService: DashboardService,
    private renderer: Renderer2,
    private _modalService: BsModalService,
    private _loaderService: LoaderService,
    private _propertyManagementService: PropertyManagementService,
    private _fileUploadService: FileUploadService,
    private _toastService: ToastService,
    private _authenticationService: AuthenticationService,
    private _validationService: ValidationService, /*private completerService: CompleterService, */private _restService: RestService) {
    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/property/GetAccounts/',null, 'Name');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/property/GetAccounts/' + x);
    //});

    //this.dataService = remoteDataProvider;
  }

  ngOnInit() {
    this.user = this._authenticationService.user
    if (this.IsPortfolio) {
      this.prospectModel.OfferOnId = 6002
    }
    else {
      this.prospectModel.OfferOnId = 6001
    }
    this.initialLoad = true;
    this.resetModel();
    this.disableProspectDetails = false;
    if (this.prospectId != null) {
      this.IsEditMode = true;
      this.prospectModel = Object.assign({}, this.prospect);
      this.prospectModel.AccountName = this.prospectModel.CompanyName;
      this.prospectModel.ProspectUserId = this.prospectModel.ProspectMasterId;
      this.disableProspectDetails = true;
      this.allowEmailEdit = this.prospectModel.Email != null && this.prospectModel.Email != '' ? false : true;
      if (this.prospectModel && this.prospectModel.LstDocuments && this.prospectModel.LstDocuments.length > 0) {
        this.prospectModel.LstDocuments.forEach(item => {
          if (item.Id && item.Id > 0 && item.Name && item.Name.length > 0) {
            const docObj =
            {
              Id: item.Id,
              name: item.Name,
              category: 417, // NDA DOC CATEGORy
              file: null,
              Url: item.Url
            }
            this.documents.push(docObj);
          }
        });
      }
    }
    this.prospectModel.PropertyId = this.propertyId;

    this.prospectForm = new FormGroup({
      'txtProspectName': new FormControl(this.prospectModel.FirstName),
      'txtLastName': new FormControl(this.prospectModel.LastName, [
        Validators.required,
        spaceOnlyValidator
      ]),
      'emailinput': new FormControl(this.prospectModel.Email, [
        Validators.required,
        spaceOnlyValidator
      ]),
      'txtCompany': new FormControl(this.prospectModel.CompanyName),
      'chkOMDownloads': new FormControl(this.prospectModel.OMDownloads),
      'chkNDAExecuted': new FormControl(this.prospectModel.NDAExecuted),
      'txtNotes': new FormControl(this.prospectModel.Notes),
      'lstFeedback': new FormControl(this.prospectModel.Feedback),
      'txtAccountName': new FormControl(this.prospectModel.AccountName, [
        Validators.required]),
      'lstStatus': new FormControl(this.prospectModel.Status, [
        Validators.required])
    })

    if (this.prospectModel != null && this.prospectModel.Id != null && this.prospectModel.Id > 0) {
      this._commonService.getProspectStatus().subscribe(response => {
        this.editStatusList = response.map(o => {
          return {
            id: o.Id, description: o.Description, typeid: o.TypeId
          };
        });
        if (this.editStatusList != null && this.editStatusList.length > 0) {
          if (this.editStatusList.findIndex(f => f.description == 'Likely Buyer') > -1) {
            let likelyBuyerId = this.editStatusList.find(f => f.description == 'Likely Buyer');
            if (likelyBuyerId != null && this.prospectModel.Status == likelyBuyerId.id) {
              this.statusList = this.editStatusList;
            }
            else {
              this.editStatusList.splice(this.editStatusList.findIndex(x => x.description == 'Likely Buyer'), 1);
              this.statusList = this.editStatusList;
            }
          }
          else {
            this.statusList = this.editStatusList;
          }
        }
      });
    }
    else {
      this._commonService.getLookupsByTypeId(44).subscribe(response => {
        this.statusList = response.map(o => {
          return {
            id: o.Id, description: o.Description, typeid: o.TypeId
          };
        });
      });
   }
    this._commonService.getLookupsByTypeId(45).subscribe(response => {
      this.feedackList = response.map(o => {
        return {
          id: o.Id, name: o.Description
        };
      });
    });
    this.loadItems();
    this.initialLoad = false;
    this.isEditable = !this.prospect || !(this.prospect.LeadDetailId || this.prospect.InquiryId) && !(this.prospect.IsOmOrNda == true);
  }
  ngAfterViewInit() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }

  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }
  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    return this._propertyManagementService.getAccountsForAutoComplete(term);
  }
  get txtProspectName() { return this.prospectForm.get('txtProspectName'); }
  get txtLastName() { return this.prospectForm.get('txtLastName'); }
  get emailinput() { return this.prospectForm.get('emailinput'); }
  get txtAccountName() { return this.prospectForm.get('txtAccountName'); }
  get txtCompany() { return this.prospectForm.get('txtCompany'); }
  get chkOMDownloads() { return this.prospectForm.get('chkOMDownloads'); }
  get chkNDAExecuted() { return this.prospectForm.get('chkNDAExecuted'); }
  get txtNotes() { return this.prospectForm.get('txtNotes'); }
  get lstFeedback() { return this.prospectForm.get('lstFeedback'); }
  get lstStatus() { return this.prospectForm.get('lstStatus'); }

  onClose() {
    this.close.emit();
  }
  saveDetails(template: TemplateRef<any>, classes) {
    this.isSubmitted = true;
    this.validateemail();
    if (this.prospectModel.AccountName == null || this.prospectModel.AccountName == '') {
      this.prospectModel.AccountName = 'Other';
      this.prospectForm.get('txtAccountName').setValue('Other');
    }
    if (this.prospectForm.valid) {
    
      this.prospectModel.CreatedBy = this.user.Id;
      this.prospectModel.CreatedDate = this._validationService.utcify(new Date());
      this.prospectModel.CompanyName = this.prospectModel.AccountName;
      if (this.prospectModel.FirstName != null && this.prospectModel.FirstName != '') {
        this.prospectModel.ProspectName = this.prospectModel.FirstName + " " + this.prospectModel.LastName;
      }
      else {
        this.prospectModel.ProspectName = this.prospectModel.LastName;
      }
      if (this.prospectModel.Status != 5007) {
        this.prospectModel.Feedback = null;
      }

      this.prospectModel.IsSFSubject = false;
        if (this.prospectModel.Status != null && this.statusList.find(x => x.id == this.prospectModel.Status).typeid == 0) {
          this.prospectModel.IsSFSubject = true;
        }
      this._loaderService.display(true);
      this._dashboardService.saveProspects(this.prospectModel).subscribe(item => {
        if (item.ErrorMessage != null && item.ErrorMessage == "Prospect already exists") {
          this._loaderService.display(false);
          this.modalRef = this._modalService.show(template, { class: classes });
        }
        else {
          this.saveDoc(item.Id);
          this._loaderService.display(false);
        }
         //this.save.emit(item);
      })
    }
  }

  resetModel() {
    this.prospectModel = {
      CompanyName: "",
      ProspectName: "",
      PropertyId: null,
      NDAExecuted: false,
      OMDownloads: false,
      Feedback: null,
      Id: 0,
      InquiryId: null,
      LeadDetailId: null,
      Notes: "",
      OfferOnId: 6001,
      Status: null,
      LstDocuments: [],
      IsCheckboxUpdate: false,
      PCount: 0,
      PrevEntry: [],
      showPrevEntries: false,
      ShortDescription: "",
      FirstName: "",
      LastName: "",
      Email: "",
      AccountName: "",
      Phone:""
    }
  }

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {

    this.filesCollection = [];
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.selectedFiles.forEach(item => {
      const fileObj =
      {
        Id: null,
        name: item["name"],
        category: 417, // NDA DOC CATEGORy
        file: item
      }
      this.filesCollection.push(fileObj);
    });
  }

  onPropertyTypeChange(id) {
    this.prospectModel.OfferOnId = id;
  }
  removeId = 0;
  onRemoveDocument(id) {

    this.removeId = id
    this.removeModalRef = this._modalService.show(this.template, { class: 'deletemodal' });
  }

  onRemoveDocuments(id) {

    if (id) {
      this.removeDocId.push(id);
    }
    let data = this.documents.filter(x => x.Id == id);
    this.documents.splice(this.documents.indexOf(data[0]), 1);
    //this.documents = this.filesCollection;        
  }
  saveDoc(Id) {

    if (this.removeDocId && this.removeDocId.length > 0) {
      this._loaderService.display(true);
      this._propertyManagementService.deleteMultipleDocument(this.removeDocId, this.user.Id).subscribe(response => {
        if (response) {
          if (this.filesCollection.length == 0) {
            this.save.emit(this.prospectModel);
            this._loaderService.display(false);
          } else {
            this.uploadFiles(Id);
          }
        }
      });
    }
    else {
      if (this.filesCollection.length == 0) {
        this.save.emit(this.prospectModel);
        this._loaderService.display(false);
      } else {
        this.uploadFiles(Id);
      }
    }
    this.removeDocId = [];
  }

  onRemoveClose() {
    this.removeModalRef.hide()
  }

  uploadFiles(Id) {
    this._loaderService.display(true);
    let valid = true;
    if (valid) {
      let uploadCount = 1;
      this.filesCollection.forEach(item => {
        this.inputFileUpload.documentName = item["name"];
        this.inputFileUpload.fileCategoryId = item["category"];
        this.inputFileUpload.id = 0;
        this.inputFileUpload.objectId = Id;
        this.inputFileUpload.objectTypeId = 315; // NDA DOC
        this.inputFileUpload.type = "Documents";

        let fileToUpload = [];
        fileToUpload.push(item["file"]);
        this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
          if (res != null) {
            if (uploadCount == this.filesCollection.length) {
              this.save.emit(this.prospectModel);
              this._loaderService.display(false);
              //this._toastService.addToast({ title: 'Success', msg: "Files Uploaded Successfully", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            }
            uploadCount++;
          }
        });
      });
      this.clearFiles++;
    }
  }

  validateemail() {
    if ((this._validationService.isEmail(this.prospectModel.Email) == false) && !this._validationService.IsinValid(this.prospectModel.Email)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this._validationService.IsinValid(this.prospectModel.Email)) {
      this.emailValid = false;
    }
  }

  gurantorListData = [];
  loadAccountData(event) {
    let filter: string = event.filter;
    this._commonService.GetAccounts(filter).subscribe(res => {
      this.accounts = res
        .map(o => {
          return {
            id: o.Id, description: o.Name
          };
        });
    });
  }

  onAccountSelect(event) {
    if (event && event.originalObject) {
      this.prospectModel.AccountId = event.Id;
    }
    else if (event && event.Name) {
      this.prospectModel.AccountId = event.Id;
    }

    if (this.prospectModel.AccountId == null || this.prospectModel.AccountId == 0) {
     this.prospectModel.AccountName = 'Other';
    }
  }

  ConfirmSaveProspects(template: TemplateRef<any>, classes) {
    this.prospectModel.AllowSave = true;
    this.modalRef.hide();
    this.saveDetails(template, classes);
  }
}
